module.exports = __webpack_public_path__ + "img/video.41273ace.png";